import { I18NService } from './../services/i18n.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ebw-change-language',
  templateUrl: './change-language.component.html',
  styleUrls: ['./change-language.component.scss']
})
export class ChangeLanguageComponent implements OnInit {

  constructor(private i18nSrv: I18NService) { }

  ngOnInit(): void {
  }

  changeLanguage(evt) {
    let lang = 'it'
    if (evt.value) {
      lang = evt.value
    }
    this.i18nSrv.changeLang(lang);
  }




}
